var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3C7.4694 3 6.9607 3.21071 6.58562 3.58579C6.21055 3.96086 5.99984 4.46957 5.99984 5C5.99984 5.53043 6.21055 6.03914 6.58562 6.41421C6.9607 6.78929 7.4694 7 7.99984 7C8.53027 7 9.03898 6.78929 9.41405 6.41421C9.78912 6.03914 9.99984 5.53043 9.99984 5C9.99984 4.46957 9.78912 3.96086 9.41405 3.58579C9.03898 3.21071 8.53027 3 7.99984 3ZM7.99984 8.33333C7.11578 8.33333 6.26794 7.98214 5.64281 7.35702C5.01769 6.7319 4.6665 5.88406 4.6665 5C4.6665 4.11595 5.01769 3.2681 5.64281 2.64298C6.26794 2.01786 7.11578 1.66667 7.99984 1.66667C8.88389 1.66667 9.73174 2.01786 10.3569 2.64298C10.982 3.2681 11.3332 4.11595 11.3332 5C11.3332 5.88406 10.982 6.7319 10.3569 7.35702C9.73174 7.98214 8.88389 8.33333 7.99984 8.33333ZM7.99984 0C4.6665 0 1.81984 2.07333 0.666504 5C1.81984 7.92667 4.6665 10 7.99984 10C11.3332 10 14.1798 7.92667 15.3332 5C14.1798 2.07333 11.3332 0 7.99984 0Z",
    fill: "#21AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlue);
export default __webpack_public_path__ + "static/media/eye-blue.b92af320fa1b6ac6161a182bc39851e0.svg";
export { ForwardRef as ReactComponent };